import useFormules from "@/shared/hooks/useFormules";
import Formule from "./Formule";
import useBranchId from "@/shared/hooks/useBranchId";

const Formules = () => {
  const branch = useBranchId();
  const formules = useFormules();
  const formuleIds = formules?.map((formule) => formule.branch.id) ?? [];

  if (formuleIds.includes(branch) === false) {
    return null;
  }

  return (
    <>
      {formules?.map((formule) => (
        <Formule branch={formule.branch} key={formule.branch.id} />
      ))}
    </>
  );
};

export default Formules;
